import React, { useEffect, useState } from "react";
import styled from "styled-components";

const SnowBackground = () => {
  const [snows, setSnows] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const size = Math.random() * 3 + 2;
      const left = Math.random() * 95;
      // const duration = Math.random() * 3 + 12;
      const duration = Math.random() * 6 + 30;
      const imgSrc = Math.floor(Math.random() * 3);
      const rotation = Math.random() * 360;

      const newSnowflake = (
        <img
          key={Math.random()}
          className="snow"
          style={{
            left: `${left}%`,
            animation: `fall ${duration}s linear, rotate infinite`,
            width: `${size}%`,
            height: `${size}%`,
            transform: `rotate(${rotation}deg)`,
          }}
          // src={
          //   imgSrc === 0
          //     ? `${process.env.PUBLIC_URL}/knockknock/svg/event/tree.svg`
          //     : imgSrc === 1
          //     ? `${process.env.PUBLIC_URL}/knockknock/svg/event/snowman.svg`
          //     : `${process.env.PUBLIC_URL}/knockknock/svg/event/santa_hat.svg`
          // }
          src={`${process.env.PUBLIC_URL}/knockknock/svg/event/snow.svg`}
          alt="snow"
        />
      );

      setSnows((prev) => [...prev, newSnowflake]);

      setTimeout(() => {
        setSnows((prev) => prev.slice(1));
      }, duration * 900);
    }, 1200);

    return () => clearInterval(interval);
  }, []);

  return (
    <Style>
      <div className="background">{snows}</div>
    </Style>
  );
};

export default SnowBackground;

const Style = styled.div`
  .background {
    width: 100vw;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: -40px;
    z-index: 10;
    opacity: 0.9;
    pointer-events: none;
    /* background: linear-gradient(0deg, #333, rgb(108, 113, 164)); */
  }
  img.snow {
    position: absolute;
    top: -50px;
    z-index: 10;
  }
  @keyframes fall {
    0% {
      top: -50px;
      opacity: 0.9;
    }
    80% {
      opacity: 0.9;
      transform: translateX(0);
    }
    100% {
      top: 100%;
      opacity: 0;
      transform: translateX(calc(var(--rotation-direction, 1) * 20px));
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(calc(var(--rotation-direction, 1) * 360deg));
    }
  }
`;
